import { useSidebar } from '../model/use-sidebar';
import { DesktopSidebar } from './sidebar-desktop';
import { MobileSidebar } from './sidebar-mobile';

export const Sidebar = () => {
  const {
    user,
    currentProject,
    currentSite,
    instanceInfo,
    isCollapsed,
    isMobileOpen,
    isMobile,
    items,
    onToggleItem,
    onToggleSidebar,
    onCloseMobile
  } = useSidebar();

  if (isMobile) {
    return (
      <MobileSidebar
        user={user}
        projectName={currentProject?.name || ''}
        siteName={currentSite?.name || ''}
        instanceName={instanceInfo?.name || ''}
        isCluster={instanceInfo?.cluster || false}
        items={items}
        isOpen={isMobileOpen}
        onToggleItem={onToggleItem}
        onClose={onCloseMobile}
      />
    );
  }

  return (
    <DesktopSidebar
      user={user}
      projectName={currentProject?.name || ''}
      siteName={currentSite?.name || ''}
      instanceName={instanceInfo?.name || ''}
      isCluster={instanceInfo?.cluster || false}
      isCollapsed={isCollapsed}
      items={items}
      onToggleItem={onToggleItem}
      onToggleSidebar={onToggleSidebar}
    />
  );
};

export default Sidebar;
